/**
 * Korean catalog — merged message map, mirrors `en/index.ts`.
 *
 * The `Record<MessageKey, string>` annotation is load-bearing: it forces the merged
 * Korean map to cover EXACTLY the English key set. If a namespace is missing here,
 * or a namespace file omits a key, the produced key set diverges from `MessageKey`
 * and this assignment fails to compile — so the two catalogs can never drift.
 */
import { flatten } from "../flatten";
import type { MessageKey } from "../en";
import { common } from "./common";
import { nav } from "./nav";
import { auth } from "./auth";
import { settings } from "./settings";
import { dashboard } from "./dashboard";
import { market } from "./market";
import { portfolio } from "./portfolio";
import { strategies } from "./strategies";
import { strategiesDetail } from "./strategiesDetail";
import { orders } from "./orders";
import { approvals } from "./approvals";
import { notifications } from "./notifications";
import { chat } from "./chat";
import { backtest } from "./backtest";
import { mobile } from "./mobile";

const namespaces = {
  common,
  nav,
  auth,
  settings,
  dashboard,
  market,
  portfolio,
  strategies,
  strategiesDetail,
  orders,
  approvals,
  notifications,
  chat,
  backtest,
  mobile,
} as const;

/** The flat Korean message map; provably key-complete against the English source. */
export const ko: Record<MessageKey, string> = flatten(namespaces);
